// extracted by mini-css-extract-plugin
export default {"BeginnerBlock":"BeginnerBlock_BeginnerBlock__HRyAl","title":"BeginnerBlock_title__hBNU3","blocks":"BeginnerBlock_blocks__VdSV-","block":"BeginnerBlock_block__ujTOX"};